import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import "./App.css";

import { Spinner } from "reactstrap";

import FormHelpers from "./helpers/FormHelpers";
import ProgressSteps from "./components/UI/Progress/ProgressSteps";
import FormArea from "./components/FormArea";
import IntroArea from "./components/IntroArea";
import PreviewArea from "./components/PreviewArea";

import config from "./store/config";
import { cardPreviewActions } from "./store/card-preview-slice";
import { fetchConfiguratorData } from "./store/configurator-actions";
import { fetchOccasionData } from "./store/card-preview-actions";

let isInitial = true;
let defaultConfiguratorState = {
  skuId: 93,
  cardType: 'sendtosomeone', 
  occasion: 1, 
  cartItemId: 0,
  apiEndpoint: 'http://localhost:25291/',
  productCollection: 7,
  csrfToken: ''
};

if (typeof window.SMA_DEFAULT_CONFIG !== "undefined") {
  config.settings = window.SMA_DEFAULT_CONFIG;
  defaultConfiguratorState = window.SMA_DEFAULT_CONFIG;
}

function App() {
  const dispatch = useDispatch();

  const currentRequestLoaded = useSelector(
    (state) => state.configurator.Loaded
  );
  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );

  const currentPreviewState = useSelector((state) => state.cardPreview);
  const currentOccasionLoaded = currentPreviewState.OccasionLoaded;

  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const hasOccasion = (currentPreviewState.Occasion != null && currentPreviewState.Occasion.Id != '' && currentPreviewState.Occasion.Id > 0);

  // load configurator state from api
  useEffect(() => {
    if (isInitial) {
      const fetchData = async () => {
        await dispatch(fetchConfiguratorData(defaultConfiguratorState));
      };

      fetchData();
    }
  }, [dispatch, isDataLoaded]);

  // load occasion data for card preview
  useEffect(() => {
    const occasion = currentRequest.DonorRequest.Occasion;

    const fetchData = async () => {
      await dispatch(fetchOccasionData(occasion));
    };

    if (currentRequestLoaded) {
      if(occasion) {
        fetchData();
      } else {
        dispatch(cardPreviewActions.setOccasionLoaded());
      }
    }

  }, [currentRequestLoaded]);

  useEffect(() => {
    
    if(currentOccasionLoaded) {
      isInitial = false;

      // if this is an update request, set preview area details to cart item details
      if(currentRequest.DonorRequest.Id) {
        const donorRequest = currentRequest.DonorRequest;

        // set selected card
        let cardPreview = {};
        currentPreviewState.Occasion.CardPreviews.forEach((card) => {
          if(card.Id == donorRequest.CardID) {
            dispatch(cardPreviewActions.setSelectedCard(card));
          }
        });

        // set signature
        dispatch(
          cardPreviewActions.setFieldValue({
            key: "CardSignature",
            value: donorRequest.CardSignature,
          })
        );

        const states = currentRequest.Lists.States;
        const provinces = currentRequest.Lists.Provinces;

        // set envelope recipient address
        dispatch(cardPreviewActions.setEnvelopeRecipientAddress({
          sendTo: donorRequest.SendTo,
          title: donorRequest.RecipientTitle,
          firstName: donorRequest.RecipientFirstName,
          lastName: donorRequest.RecipientLastName,
          address1: donorRequest.RecipientAddress1,
          address2: donorRequest.RecipientAddress2,
          country: donorRequest.RecipientCountry,
          state: FormHelpers.getStateProvinceCode(states, donorRequest.RecipientStateProvince),
          province: FormHelpers.getStateProvinceCode(provinces, donorRequest.RecipientStateProvince),
          city: donorRequest.RecipientCity,
          postalCode: donorRequest.RecipientZipPostalCode
        }));

        // set envelope return address
        dispatch(cardPreviewActions.setEnvelopeReturnAddress({
          useAddress: donorRequest.UseAddress,
          title: donorRequest.ReturnTitle,
          firstName: donorRequest.ReturnFirstName,
          lastName: donorRequest.ReturnLastName,
          address1: donorRequest.ReturnAddress1,
          address2: donorRequest.ReturnAddress2,
          country: donorRequest.ReturnCountry,
          state: FormHelpers.getStateProvinceCode(states, donorRequest.ReturnStateProvince),
          province: FormHelpers.getStateProvinceCode(provinces, donorRequest.ReturnStateProvince),
          city: donorRequest.ReturnCity,
          postalCode: donorRequest.ReturnZipPostalCode
        }));

      }

      setIsDataLoaded(true);
    }

  }, [currentOccasionLoaded]);


  if (isDataLoaded) {
    return (
      <div className="cfg">
        <ProgressSteps />
        <div className="row">
          <div className="col-sm-12 col-lg-4">
            <FormArea />
          </div>
          <div className="col-sm-12 col-lg-8">
            {!hasOccasion && <IntroArea />}
            {hasOccasion && <PreviewArea />}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="loading-spinner">
        <Spinner color="primary">Loading...</Spinner>
      </div>
    );
  }
}

export default App;
